/**
 * The one avatar rule for a CPM campaign, wherever it is shown (/earn cards,
 * the /campaign-audit list, the audit detail hero): the campaign's own logo,
 * else its first YouTube channel's thumbnail, else the name's initials.
 */

export type CampaignAvatarInput = {
  name?: string | null;
  logo_url?: string | null;
  youtube_channels?: ReadonlyArray<{ thumbnail?: string | null } | null> | null;
};

export type CampaignAvatar = {
  /** Image to show, or null to render the initials. */
  src: string | null;
  initials: string;
};

function present(value: string | null | undefined): string | null {
  return value && value.trim() ? value : null;
}

/** First letter of the first two words, upper-cased ("Sistema Viral | …" → "SV"). */
export function campaignInitials(name: string | null | undefined): string {
  return (name || '')
    .trim()
    .split(/\s+/)
    .map((word) => word.charAt(0))
    .join('')
    .toUpperCase()
    .slice(0, 2);
}

export function resolveCampaignAvatar(campaign: CampaignAvatarInput): CampaignAvatar {
  const firstChannel = (campaign.youtube_channels || [])[0] ?? null;
  return {
    src: present(campaign.logo_url) || present(firstChannel?.thumbnail) || null,
    initials: campaignInitials(campaign.name),
  };
}
